var cov_1p82ik5law = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Dropdown/styles/index.js",
      hash = "757167cb9fd5874e473048ece90ef19e0e2b7f81",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Dropdown/styles/index.js",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 29
        },
        end: {
          line: 5,
          column: 65
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var dropdownLess = {};
import genaration from '../../utils/classname';
export var dropdownClass = (cov_1p82ik5law.s[0]++, genaration(dropdownLess, 'dropdown'));